<script>
import { mapActions } from 'vuex'
import { add, edit } from '@/api/acessogrupo'
import { setFocus } from '@/services/crud'
import fields from './fields'
import gridTela from './gridTela'
import gridFuncionalidade from './gridFuncionalidade'

export default {
  components: {
    gridTela,
    gridFuncionalidade
  },
  props: {
    mode: { type: String, default: 'tab' }
  },
  data: () => ({
    fields,
    form: {},
    indFunc: -1
  }),
  computed: {
    funcionalidades: {
      get () {
        if (this.indFunc !== -1) return this.form.telas[this.indFunc].funcionalidades
        return []
      },
      set (val) {
        if (this.indFunc !== -1) this.form.telas[this.indFunc].funcionalidades = val
      }
    }
  },
  methods: {
    ...mapActions({
      toaster: 'modal/toaster'
    }),
    focuInicial () {
      setFocus('input[type="text"]', this.$refs.form.$el)
    },
    refresh (data) {
      this.form = JSON.parse(JSON.stringify(data))
      if (!this.form.id) this.$refs.form.instance.resetValues()
      this.focuInicial()
      this.indFunc = -1
    },
    async selecionaTela (row) {
      let ind = this.form.telas.findIndex(e => e.id === row.id)
      if (ind !== -1) {
        this.indFunc = ind
        this.funcionalidades = this.form.telas[ind].funcionalidades
      } else this.indFunc = -1
    },
    async salvar () {
      // Salvar Editar
      try {
        let valida = this.$refs.form.instance.validate()
        if (!valida.isValid) throw new Error('Campos Inválidos')
        let data = {}
        if (this.form.id) {
          data = await edit(this.form.id, this.form)
          this.toaster({ message: 'Editado com sucesso!', color: 'success' })
        } else {
          data = await add(this.form)
          this.toaster({ message: 'Adicionado com sucesso!', color: 'success' })
        }
        this.$emit('save', data)
      } catch (e) {
        this.toaster({ message: e.message, color: 'error' })
      }
    }
  }
}
</script>

<template>
  <ui-layout-modal :mode="mode" title="Adicionar" @onClose="() => $emit('cancel')">
    <dx-form ref="form" label-location="top" :form-data="form" :items="fields" :onEditorEnterKey="salvar">
      <grid-tela slot="templateTela" slot-scope="data" :model="form.telas" @change="e => form.telas = e" @selectrow="selecionaTela" />
      <grid-funcionalidade class="template-funcionalidade" slot="templateFuncionalidade" slot-scope="data" :model="funcionalidades" @change="e => funcionalidades = e" />
    </dx-form>
    <ui-acao-form @save="salvar" @cancel="$emit('cancel')" />
  </ui-layout-modal>
</template>

<style scoped>
  .card-form {
    text-align: left;
  }
  .template-funcionalidade {
    margin-top: 60px;
  }
</style>
